;(function (global, factory) {
    typeof define === 'function' && define.amd ? define('score_bootstrap/Components/GoogleMap',["jquery", 'loglevel'], factory) :
    typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("jquery"), require('loglevel')) :
    console && console.error('GoogleMap does not support non-amd script loading.');
}(this/* window */, function ($, log) {
    var defaultLat = 0, defaultLng = 0, defaultZoom = 12;

    function GoogleMap(scope, lat, lng, zoom, allowZoom, allowPan) {
        var $mapCanvas = $(".google-map-canvas", scope), $pinElements, center, map, $panel;

        if (!$mapCanvas.length) {
            log.warn("Skipping GoogleMap initialization, cannot find .google-map-canvas element");
            return;
        }
        log.debug(allowPan);
        $pinElements = $(".google-map-pin", $mapCanvas).remove();
        center = new google.maps.LatLng(lat, lng);
        map = new google.maps.Map($mapCanvas[0], {
            center: center,
            zoom: zoom,
            scrollwheel: false,
            zoomControl: allowZoom,
            disableDoubleClickZoom: !allowZoom,
            draggable: allowPan,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            panControl: allowPan
        });

        $pinElements.each(function () {
            var $pin = $(this);
            var description = $pin.html().trim();
            var marker = new google.maps.Marker({
                position: new google.maps.LatLng(parseFloat($pin.attr("data-lat")), parseFloat($pin.attr("data-lng"))),
                map: map,
                title: $pin.attr("data-title"),
                cursor: description ? 'pointer' : 'default'
            });

            if (description) {
                description = new google.maps.InfoWindow({ content: description });
                marker.addListener('click', function () {
                    description.open(map, marker);
                });
            }
        });

        google.maps.event.addListenerOnce(map, "idle", (function ($canvas) {
            var $iframe = $("iframe", $canvas);
            if ($iframe.length > 0) {
                $iframe.attr("title", "Google Map");
            }
        }).bind(null, $mapCanvas));

        $mapCanvas.show();

        // The map must be visible at the time when it is rendered, otherwise it does not render correctly.
        // In some cases, it is not visible on page load and needs to be rerendered manually.
        function rerender() {
            google.maps.event.trigger(map, 'resize');
            map.setCenter(center);
            map.setZoom(zoom);
        }

        // If the map is inside a variable column then it needs to be rerendered after it has been
        // initialized, otherwise it looks weird because its initialized while the width is 0.
        if ($mapCanvas.closest(".score-variable-column").length) {
            rerender();
        }

        // If the map is inside a hidden accordion/tab/modal panel, it needs to be rerendered when that panel is made visible.
        $panel = $mapCanvas.closest(".score-accordion-panel");
        if ($panel.length) {
            $panel.on("shown.bs.collapse", rerender);
        }

        $panel = $mapCanvas.closest(".score-tab");
        if ($panel.length) {
            $panel.on("shown.bs.tab", rerender);
        }

        $panel = $mapCanvas.closest(".score-modal");
        if ($panel.length) {
            $panel.on("shown.bs.modal", rerender);
        }

        // If the map is inside a hidden carousel pane it needs to be rerendered when that pane is made visible.
        $panel = $mapCanvas.closest(".score-carousel");
        if ($panel.length) {
            $panel.on("slid.bs.carousel", rerender);
        }
    }

    GoogleMap.init = function init(args) {
        return args.IsEditorEditing === true ? null : new GoogleMap(
            args.scope,
            parseFloat(args.Latitude) || defaultLat,
            parseFloat(args.Longitude) || defaultLng,
            parseInt(args.ZoomLevel || defaultZoom, 10),
            Boolean(args.AllowsZoom),
            Boolean(args.AllowsPan)
        );
    };

    //requireJS load handler - used for passing google maps key to require module definition
    GoogleMap.load = function (name, req, onLoad) {
        // load google deps with google key
        require(["https://maps.googleapis.com/maps/api/js?v=quarterly&key=" + name + "&libraries=places"], function () {
            onLoad(GoogleMap);
        });
    }

    return GoogleMap;
}));
